import React from "react"
import { Button, Col } from "react-bootstrap"
import FontAwesome from "react-fontawesome"
import apiServerApi from "../../redux/sagas/apiServerApi"
import { blockingFetchService } from "../../lib/blockingFetch"
import ProcessesStatus from "../fragments/ProcessesStatus"
import { connect } from "react-redux"
import CustomBreadCrumb from "../fragments/CustomBreadCrumb"
import { getOrganization, saveOrganization } from "../../lib/utils"

class LoanVerification extends React.Component {

  state = {
    running: false,
    success: false,
    error: null,
    organization: null,
    loanVerifType: null,
  }

  componentDidMount() {
    this.loadOrganization()
  }

  loadOrganization = () => {

    const organization = getOrganization()
    if(!organization) return

    blockingFetchService(
      accessToken => apiServerApi.getOrganizationById(accessToken, organization.id),
      organization => this.setState({
        organization,
        loanVerifType: organization.loanVerificationType
      }),
      error => this.setState({ error: error.text }),
      _ => {}
    )
  }

  saveClicked = () => {

    const { loanVerifType } = this.state

    if(!loanVerifType) {
      this.setState({ error: "Please choose a verification type" })
      return
    }

    this.setState({ running: true })

    blockingFetchService(
      accessToken => apiServerApi.setLoanVerificationType(accessToken, loanVerifType),
      organization => {

        this.setState({ 
          organization,
          success: true,
          loanVerifType: organization.loanVerificationType,
        })
        saveOrganization(organization)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  render() {

    const enumType = [ 'NONE', 'ONE_STEP', 'TWO_STEP' ],
  
    enumName = [
      'No loan application verification',
      'One layer of verification',
      'Two layers of verification'
    ],

    { organization, loanVerifType, running, success, error } = this.state

    return (
      <div>

        <CustomBreadCrumb activeText='Loan verification' data={ [{ url: '/settings', title: 'Settings' }] } />

        <Col mdOffset={1} md={6} className="simple-form margin-bottom-40">

          <h4>Choose the type of verification to apply on the loans</h4>

          <div className="radio-loantype">
          {
            enumType.map((value, index) => {
              return <span key={ index }>
                <label htmlFor={`loantype${index}`}>
                  <input type="radio"
                    value={ value }
                    onClick={e => this.setState({ loanVerifType: e.target.value })}
                    id={`loantype${ index }`}
                    checked={ loanVerifType === value }
                    name="loantype"
                  />&nbsp;
                  { enumName[index] }
                </label><br/>
              </span>
            })
          }
          </div>

          <ProcessesStatus error={ error } running={ running } success={ success } />

          <div className="align-right">
            <Button bsStyle="success"
              disabled={ !organization || loanVerifType === organization.loanVerificationType }
              onClick={ this.saveClicked }>
              <FontAwesome name='save'/> Apply setting
            </Button>
          </div>

        </Col>

        <Col md={5}>
          <h4>Verification types</h4>
          <ul>
            <li><strong>No loan application verification</strong><br/>Nobody checks the loans, they are automatically marked as APPROVED/COMPLETED.</li>
            <li><strong>One layer of verification</strong><br/>Only UNDERWRITER accounts will approve loans.</li>
            <li><strong>Two layers of verification</strong><br/>Both UNDERWRITER and APPROVER accounts will approve loans.</li> 
          </ul>
        </Col>

      </div>
    )
  }
}

export default connect()(LoanVerification)



// WEBPACK FOOTER //
// ./src/components/Settings/LoanVerification.js